const PUBLIC_STUN = { urls: "stun:stun.l.google.com:19302" };

/** Browser ICE servers remain mode-specific; a missing fleet host fails closed. */
export const buildBrowserIceServers = (host, isFleetMode) => {
    if (isFleetMode) {
        if (!host) return [];
        return [
            { urls: `turn:${host}:3478`, username: "r2c2", credential: "r2c2" },
            PUBLIC_STUN,
        ];
    }

    const hostname = typeof window !== "undefined" ? window.location.hostname : "";
    return hostname ? [{ urls: `stun:${hostname}:3478` }] : [];
};

/** Fleet producers use browser ICE by default; host-only remains an override. */
export const buildProducerIceServers = (host, isFleetMode, producerPolicy) => {
    if (!isFleetMode || (producerPolicy && producerPolicy !== "browser")) return [];
    return buildBrowserIceServers(host, true);
};
